export default {
    excluded: 'Exclu',
    lost: 'Perdu',
    recycled: 'Recyclé',
    retail: 'Détail',
    return: 'Retour',
    wholesale: 'Wholesale',
};
